import { create } from "zustand";
import { calculatePositionPnL } from "../../utils/calculatePositionPnL";

export const useClosedPositionStore = create((set, get) => ({

  positions: [],
  version: 0,   // 🔥 UI re-render trigger

  //-------------------------------------------
  // INITIAL LOAD
  //-------------------------------------------
  setInitialClosedPositions: (positions) => {
    set({
      positions,
      version: get().version + 1,
    });
  },

  //-------------------------------------------
  // ADD / UPDATE POSITION (by ID only)
  //-------------------------------------------
  addOrUpdatePosition: (incoming) => {
    set((state) => {
      const incomingId = String(incoming.id);

      const idx = state.positions.findIndex(
        (p) => String(p.id) === incomingId
      );

      let newPositions;

      if (idx !== -1) {
        console.log(
          `🔄 Updating Position → ID: ${incomingId}, Symbol: ${incoming.symbol}`
        );

        newPositions = [...state.positions];
        newPositions[idx] = {
          ...newPositions[idx],
          ...incoming,
          last_updated: new Date().toISOString(),
        };
      } else {
        console.log(
          `🟢 Adding NEW Position → ID: ${incomingId}, Symbol: ${incoming.symbol}`
        );

        newPositions = [...state.positions, incoming];
      }

      return {
        positions: newPositions,
        version: state.version + 1, // 🔥 force UI update
      };
    });
  },

  //-------------------------------------------
  // REMOVE POSITION (old 3-key match)
  //-------------------------------------------
  removePosition: ({ client_id, symbol, strategy }) => {
    set((state) => ({
      positions: state.positions.filter(
        (p) =>
          !(
            String(p.client_id) === String(client_id) &&
            String(p.symbol) === String(symbol) &&
            String(p.strategy) === String(strategy)
          )
      ),
      version: state.version + 1,
    }));
  },

  //-------------------------------------------
  // REMOVE BY ID
  //-------------------------------------------
  removePositionById: (id) => {
    if (!id) return;

    console.log(`🗑️ Removing Position → ID: ${id}`);

    set((state) => ({
      positions: state.positions.filter(
        (p) => String(p.id) !== String(id)
      ),
      version: state.version + 1,
    }));
  },

  //-------------------------------------------
  // UPDATE LTP + PNL
  //-------------------------------------------
  updatePositionLtp: (symbol, ltp, timestamp) => {
    set((state) => ({
      positions: state.positions.map((p) => {
        if (String(p.symbol) !== String(symbol)) return p;

        const pnl = calculatePositionPnL(p, ltp);

        return {
          ...p,
          ltp,
          current_ltp: ltp,
          pl: pnl,
          last_updated: timestamp || new Date().toISOString(),
        };
      }),
      version: state.version + 1,   // 🔥 re-render for LTP updates also
    }));
  },

}));
